import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای تخصیص اپراتور به گروه‌های کاری (Roster Assignments)

این صفحه برای تخصیص دوره‌ای یا دائمی اپراتورها به الگوهای شیفت (Roster) در ایستگاه‌های کاری مختلف طراحی شده است.

## ۱. نحوه تخصیص اپراتور جدید
برای تخصیص شیفت و ایستگاه کاری به یک اپراتور، در بخش **"تخصیص اپراتور"** مقادیر زیر را تکمیل کنید:

- **اپراتور:** نام و شناسه اپراتور مورد نظر را انتخاب کنید.
- **گروه کاری (Roster):** گروه شیفتی که این شخص در آن فعالیت خواهد کرد (مثلاً شیفت چرخشی A یا شیفت ثابت صبح) را مشخص کنید. مدیریت این الگوهای چرخشی در صفحه [مدیریت گروه‌های کاری](/production/shopfloor/rosters) انجام می‌شود.
- **ایستگاه کاری (Work Center):** بخشی از خط تولید که شخص در آن مستقر خواهد شد را تعیین کنید.
- **تاریخ شروع:** روزی که این تخصیص از آن اعمال می‌شود را روی تقویم شمسی انتخاب نمایید.

> **نکته:** پس از زدن دکمه «تخصیص»، برنامه کاری اپراتور تا زمانی که تخصیص جدیدی ثبت نشود یا پایان نیابد، طبق الگوی Roster محاسبه و مشخص می‌گردد.

## ۲. مشاهده وضعیت و بررسی شیفت
در قسمت **"تست استخراج شیفت مؤثر"** می‌توانید تاریخ و نام یک اپراتور را وارد کنید تا سیستم بر اساس تمامی الگوها، مرخصی‌ها و جابجایی‌ها به شما بگوید در آن روز دقیقاً چه شیفتی (عادی، اضافه‌کاری، تعطیلی و ...) برای وی محاسبه می‌شود.

## ۳. لیست تخصیص‌های فعال
در جدول پایین صفحه، لیست تمامی افرادی که هم‌اکنون به گروه‌های کاری متصل هستند نمایش داده می‌شود. شما می‌توانید نام، گروه، بخش کاری، تاریخ شروع تخصیص و وضعیت هر نفر را در یک نگاه مشاهده کنید.


export default Layout;
